import React, { FC, useState } from 'react';
import { Button, Table } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useContentLoader } from 'common/hooks/useContentLoader';
import { ContentLoader } from 'common/components/ContentLoader';
import { toDataSourceMapper } from 'common/helpers/common.helper';
import { LIST_LIMIT_0 } from 'common/config';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { listDataToAddContractSelectOptions, renderContractListForSuperAdminRecords } from 'entities/Contract/Contract.helper';
import { AddContractModal } from 'entities/Modal/components/AddContractModal';
import { getAccounts, selectAccountList } from 'entities/Account/Account.slice';
import {
  createContract,
  deleteContract,
  getContractList,
  selectContractList,
  selectIsContractLoading,
} from 'entities/Contract/Contract.slice';
import { getSellerList, selectSellerList } from 'entities/Seller/Seller.slice';

export const ContractListForSuperAdmin: FC = () => {
  const dispatch = useAppDispatch();
  // account
  const accountList = useAppSelector(selectAccountList);
  // contract
  const contractList = useAppSelector(selectContractList);
  const isContractLoading = useAppSelector(selectIsContractLoading);

  const sellerList = useAppSelector(selectSellerList);

  const [sellerId, setSellerId] = useState<number | null>(null);
  const [buyerId, setBuyerId] = useState<number | null>(null);
  const [openAddContractModal, setOpenAddContractModal] = useState<boolean>(false);

  const dataSource = toDataSourceMapper(contractList);
  const columns = renderContractListForSuperAdminRecords(onDeleteContractClick);
  const sellerOptions = listDataToAddContractSelectOptions(sellerList);
  const buyerOptions = listDataToAddContractSelectOptions(accountList);

  function onDeleteContractClick(contractId: number) {
    dispatch(deleteContract({ id: contractId }));
  }

  const onAddContractClick = () => {
    setOpenAddContractModal(true);
  };

  const onAddContractModalCancel = () => {
    setSellerId(null);
    setBuyerId(null);
    setOpenAddContractModal(false);
  };

  const onAddContractModalAdd = () => {
    if (sellerId && buyerId) {
      dispatch(createContract({ sellerId, buyerId, onSuccess: onAddContractModalCancel }));
    }
  };

  const { contentLoading } = useContentLoader(async () => {
    await dispatch(getContractList({ limit: 0 }));
    await dispatch(getSellerList({ limit: 0 }));
    dispatch(getAccounts({ isSeller: false, limit: LIST_LIMIT_0 }));
  });

  return (
    <div className="contract-list">
      {contentLoading ? (
        <ContentLoader />
      ) : (
        <>
          <div className="contract-list__title">Список контрактов</div>

          <Button className="btn btn-primary" onClick={onAddContractClick}>
            <PlusOutlined />

            <span>Контракт</span>
          </Button>

          <Table
            className="contract-list__table"
            dataSource={dataSource}
            columns={columns}
            showHeader={false}
            pagination={false}
            loading={isContractLoading}
            locale={{ emptyText: 'Список пуст. Создайте новый контракт.' }}
          />
        </>
      )}

      <AddContractModal
        open={openAddContractModal}
        loading={isContractLoading}
        sellerOptions={sellerOptions}
        buyerOptions={buyerOptions}
        sellerId={sellerId}
        buyerId={buyerId}
        changeSellerId={setSellerId}
        changeBuyerId={setBuyerId}
        onCancel={onAddContractModalCancel}
        onAdd={onAddContractModalAdd}
      />
    </div>
  );
};
